<div class="maintenance-container">
  <div class="result-wrapper">
    <div class="logo-wrapper">
      <img
        src="assets/images/longhealth-navbar-logo.png"
        alt="LongHealth Logo"
        class="maintenance-logo"
      />
    </div>
    <nz-result
      nzStatus="warning"
      nzTitle="We are currently under maintenance"
      nzSubTitle="We will be back shortly. Thank you for your patience."
    >
      <div nz-result-extra>
        <div class="maintenance-icon-wrapper">
          <nz-icon nzType="tool" nzTheme="outline" class="maintenance-icon"></nz-icon>
        </div>
        <p class="maintenance-message">
          Our team is working hard to improve your experience. Please check back soon!
        </p>
      </div>
    </nz-result>
  </div>
</div>
